module.exports = __webpack_public_path__ + "img/people-03.0159153e.png";